import { Link } from "react-router-dom";
import { money } from "../api";
import { useCart } from "../context/CartContext";

export default function Cart() {
  const { items, updateQty, remove, count, subtotal } = useCart();

  return (
    <>
      <div className="page-hero">
        <div className="container">
          <h1>Your cart</h1>
          <p>
            {count} item{count === 1 ? "" : "s"} ready for checkout
          </p>
        </div>
      </div>

      <div className="container" style={{ paddingBottom: "4rem" }}>
        {!items.length ? (
          <div className="empty-state">
            <h2>Your cart is empty</h2>
            <p>Browse injera, breads, snacks, and more.</p>
            <Link className="btn btn-primary" to="/shop">
              Go shopping
            </Link>
          </div>
        ) : (
          <>
            <div className="cart-list">
              {items.map((item) => (
                <div className="cart-row" key={item.id}>
                  <Link to={`/product/${item.slug}`} className="cart-item">
                    <img src={item.image} alt="" />
                    <div>
                      <strong>{item.name}</strong>
                      <div className="muted">{money(item.price)} each</div>
                    </div>
                  </Link>
                  <div className="qty-control">
                    <button type="button" onClick={() => updateQty(item.id, item.qty - 1)}>
                      −
                    </button>
                    <input
                      type="number"
                      value={item.qty}
                      min={1}
                      max={99}
                      onChange={(e) => updateQty(item.id, Number(e.target.value) || 1)}
                    />
                    <button type="button" onClick={() => updateQty(item.id, item.qty + 1)}>
                      +
                    </button>
                  </div>
                  <div className="cart-line-total">{money(item.price * item.qty)}</div>
                  <button type="button" className="btn btn-ghost btn-sm" onClick={() => remove(item.id)}>
                    Remove
                  </button>
                </div>
              ))}
            </div>

            <div className="cart-summary">
              <div className="row">
                <span>Subtotal</span>
                <strong>{money(subtotal)}</strong>
              </div>
              <div className="row total">
                <span>Total</span>
                <span>{money(subtotal)}</span>
              </div>
              <Link className="btn btn-primary" to="/checkout" style={{ width: "100%", marginTop: "1rem" }}>
                Checkout
              </Link>
              <Link className="btn btn-ghost" to="/shop" style={{ width: "100%", marginTop: ".5rem" }}>
                Continue shopping
              </Link>
            </div>
          </>
        )}
      </div>
    </>
  );
}
